var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwimmingSuit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nol0fshgya)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.78 16.697V.91H6.324v18.522L3.057 30.45c-.845 2.85-.55 5.917.825 8.553l2.443 4.684v13.169L.498 68.78v3.818l6.782 2.064a17.183 17.183 0 0 1 11.347 11.154l2.3 7.115h5.25l5.391-37.098-5.392-30.74a8.397 8.397 0 0 1-8.397-8.398z",
    fill: "#FFE477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.027 56.856V43.687l2.443-4.684a11.456 11.456 0 0 0 .825-8.553l-3.268-11.018V.91H34.572v15.787a8.397 8.397 0 0 1-8.396 8.396v67.839h5.25l2.3-7.115a17.183 17.183 0 0 1 11.346-11.154l6.782-2.064v-3.818l-5.827-11.925z",
    fill: "#FFB655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.866 52.561-1.684 22.788 1.631 2.25-2.237 5.953-.693 9.38h25.4V82.128c0-3.122 2.565-5.653 5.728-5.653l1.797-13.017-1.797-12.693-28.145 1.797z",
    fill: "#4894FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.138 92.933-.693-9.38-2.13-4.51 1.524-3.694-1.684-22.788-28.145-1.797v25.71c3.163 0 5.727 2.53 5.727 5.653v10.806h25.4z",
    fill: "#046EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.586 50.764h5.392v16.668h-5.392V50.764z",
    fill: "#FFF5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.041 50.764h5.392v16.668H64.04V50.764z",
    fill: "#DCE6EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.558 52.069v10.597c0 2.14-.87 4.23-2.387 5.738l-6.99 6.945-.607 8.202L41.971 72.23a13.569 13.569 0 0 0 3.979-9.563V51.725l-5.392.344z",
    fill: "#046EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.838 75.349-6.99-6.945a8.14 8.14 0 0 1-2.388-5.738V52.07l-5.392-.344v10.941c0 3.565 1.45 7.05 3.98 9.563l11.396 11.322-.606-8.202z",
    fill: "#0051BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.008 41.254h-27.31l-.835 11.306h28.145l1.798-5.64-1.797-5.666z",
    fill: "#6AA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.153 52.56-.835-11.306h-27.31V52.56h28.145z",
    fill: "#4894FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nol0fshgya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.307 .912)",
    d: "M0 0h92.021v92.021H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwimmingSuit);
export default __webpack_public_path__ + "static/media/swimming-suit.107864331873e27133c033967e68ae12.svg";
export { ForwardRef as ReactComponent };